import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import withRouter from "./Common/withRouter";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { changeLayoutMode } from "../store/actions";
import { useAuthStatus } from "../hooks/useAuthStatus";
import FullScreenSpinner from "./Common/FullScreenSpinner";

const ALLOWED_PUBLIC_PATHS = new Set(["/logout", "/auth/action"]);

const NonAuthLayout = (props) => {

  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthenticated, isEmailVerified, isLoading } = useAuthStatus();

  const selectProperty = createSelector(
    (state) => state.Layout,
    (layout) => ({
      layoutModeType: layout.layoutModeType,
    })
  )
  const { layoutModeType } = useSelector(selectProperty);

  useEffect(() => {
    if (layoutModeType) {
      dispatch(changeLayoutMode(layoutModeType))
    }
  }, [layoutModeType,])

  if (isLoading) {
    return <FullScreenSpinner />;
  }

  if (isAuthenticated && !isEmailVerified && !ALLOWED_PUBLIC_PATHS.has(location.pathname)) {
    return <Navigate to={`/verify-email?returnUrl=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};

NonAuthLayout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object,
};

export default withRouter(NonAuthLayout);
